import React from "react";
import { RowActions } from "./DataRows";

interface GetColumnsProps {
    tableData: any[];
    setTableData: any;
    editRowId: number | null;
    setEditRowId: any;
    editRowValues: any;
    setEditRowValues: any;
    selectedRows: Set<number>;
    setSelectedRows: any;
    t: (key: string) => string;
}

export const getColumns = ({
    tableData,
    setTableData,
    editRowId,
    setEditRowId,
    editRowValues,
    setEditRowValues,
    selectedRows,
    setSelectedRows,
    t,
}: GetColumnsProps) => [
    // {
    //   id: "select",
    //   header: "",
    //   cell: ({ row }: any) => (
    //     <input
    //       type="checkbox"
    //       checked={selectedRows.has(row.original.id)}
    //       onChange={() => {
    //         const newSet = new Set(selectedRows);
    //         if (newSet.has(row.original.id)) newSet.delete(row.original.id);
    //         else newSet.add(row.original.id);
    //         setSelectedRows(newSet);
    //       }}
    //     />
    //   ),
    // },
    {
        accessorKey: "id",
        header: t("id"),
        cell: (info: any) => info.getValue(),
    },
    {
        accessorKey: "type.name",
        header: t("request_name"),
        cell: ({ row, getValue }: any) =>
            editRowId === row.original.id ? (
                <input
                    value={editRowValues.type?.name || ""}
                    onChange={(e) =>
                        setEditRowValues({
                            ...editRowValues,
                            type: {
                                ...editRowValues.type,
                                name: e.target.value,
                            },
                        })
                    }
                    className="border rounded px-1 py-0.5 w-full"
                />
            ) : (
                getValue()
            ),
    },
    {
        accessorKey: "type.category",
        header: t("category"),
        cell: ({ row, getValue }: any) =>
            editRowId === row.original.id ? (
                <input
                    value={editRowValues.type?.category || ""}
                    onChange={(e) =>
                        setEditRowValues({
                            ...editRowValues,
                            type: {
                                ...editRowValues.type,
                                category: e.target.value,
                            },
                        })
                    }
                    className="border rounded px-1 py-0.5 w-full"
                />
            ) : (
                getValue()
            ),
    },
    {
        accessorKey: "type.subcategory",
        header: t("subcategory"),
        cell: ({ row, getValue }: any) =>
            editRowId === row.original.id ? (
                <input
                    value={editRowValues.type?.subcategory || ""}
                    onChange={(e) =>
                        setEditRowValues({
                            ...editRowValues,
                            type: {
                                ...editRowValues.type,
                                subcategory: e.target.value,
                            },
                        })
                    }
                    className="border rounded px-1 py-0.5 w-full"
                />
            ) : (
                getValue()
            ),
    },
    {
        accessorKey: "request_type",
        header: t("request_type"),
        cell: ({ row, getValue }: any) =>
            editRowId === row.original.id ? (
                <input
                    value={editRowValues.request_type || ""}
                    onChange={(e) =>
                        setEditRowValues({
                            ...editRowValues,
                            request_type: e.target.value,
                        })
                    }
                    className="border rounded px-1 py-0.5 w-full"
                />
            ) : (
                getValue()
            ),
    },
    {
        accessorKey: "type.required_docs",
        header: t("required_docs"),
        cell: ({ row, getValue }: any) =>
            editRowId === row.original.id ? (
                <input
                    value={(editRowValues.type?.required_docs || []).join(", ")}
                    onChange={(e) =>
                        setEditRowValues({
                            ...editRowValues,
                            type: {
                                ...editRowValues.type,
                                required_docs: e.target.value.split(","),
                            },
                        })
                    }
                    className="border rounded px-1 py-0.5 w-full"
                />
            ) : (
                (getValue() as string[]).join(", ")
            ),
    },
    {
        id: "actions",
        header: t("actions"),
        cell: ({ row }: any) => (
            <RowActions
                row={row}
                selectedRows={selectedRows}
                tableData={tableData}
                setTableData={setTableData}
                editRowId={editRowId}
                setEditRowId={setEditRowId}
                editRowValues={editRowValues}
                setEditRowValues={setEditRowValues}
            />
        ),
    },
];
